/* ---------------------------------------------------------------------------------------------------------------------
NEWSLETTER JS
--------------------------------------------------------------------------------------------------------------------- */
jQuery(document).ready(function ($) {
    $('input[name="EMAIL"]').keypress(function(event) {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if(keycode === '13') {
            event.preventDefault();
            $('#newsletter_modal').modal('show')
        }
        event.stopPropagation();
    });

    var disableSubmit = false;
    $('input.wpcf7-submit[type="submit"]').click(function() {
        $(':input[type="submit"]').attr('value',"Sending...");
        if (disableSubmit === true) {
            return false;
        }
        disableSubmit = true;
        return true;
    });

    var wpcf7Elm = $('.wpcf7');
    wpcf7Elm.on( 'wpcf7submit', function( event ) {
        $(':input[type="submit"]').attr('value',"Send");
        disableSubmit = false;
    }, false );
});



